import { localeHref, routeLocale, withoutLocale, type Locale } from "../../i18n/routing"

export const externalBookingUrl = "https://book.mylimobiz.com/v4/danarolimo"
export type BookingMode = "external" | "admin_preview" | "native"
export type BookingChannel = { enabled: boolean; version: number; mode: BookingMode; guestPreviewEnabled?: boolean; preview?: boolean; accountBookingUrl?: string; accountHomeUrl?: string }
export type BookingIntent = "journey" | "visit" | "manage"
export const bookingResponseHeaders = {
  "Cache-Control": "private, no-store",
  "Referrer-Policy": "no-referrer",
  "X-Robots-Tag": "noindex, nofollow",
  Vary: "Cookie",
}
const entryPaths = new Set(["/reserve", "/reserve/trip", "/reserve/vehicles", "/reserve/details", "/reserve/review", "/showroom-visit", "/manage-reservation"])
export function isBookingEntry(path: string) { return entryPaths.has(withoutLocale(path).replace(/\/+$/, "")) }

export function bookingHref(intent: BookingIntent = "journey", options: Record<string, string | undefined> = {}, locale: Locale = "en") {
  const search = new URLSearchParams({ intent })
  for (const key of ["vehicle", "service", "category", "companyId", "configuration", "package"]) {
    const value = options[key]
    if (value && /^[a-zA-Z0-9_-]{1,120}$/.test(value)) search.set(key, value)
  }
  return `${localeHref("/book/", locale)}?${search}`
}

export function resolveBookingDestination(channel: BookingChannel, intent: BookingIntent, locale: Locale, search = new URLSearchParams()) {
  if (!channel.enabled) return externalBookingUrl
  const path = localeHref(intent === "visit" ? "/showroom-visit/" : intent === "manage" ? "/account/" : "/reserve/", locale)
  const filtered = new URLSearchParams(bookingHref(intent, Object.fromEntries(search), locale).split("?")[1])
  filtered.delete("intent")
  return path + (intent !== "manage" && filtered.size ? `?${filtered}` : "")
}

/** Normalize only known public entry links, never private record/token URLs. */
export function normalizeBookingHref(href: string) {
  if (href === externalBookingUrl || href === externalBookingUrl + "/") return bookingHref()
  if (!href.startsWith("/") || href.startsWith("//")) return href
  const url = new URL(href, "https://danaro.invalid")
  if (!isBookingEntry(url.pathname)) return href
  const path = withoutLocale(url.pathname)
  const intent = path.startsWith("/showroom-visit") ? "visit" : path.startsWith("/manage-reservation") ? "manage" : "journey"
  return bookingHref(intent, Object.fromEntries(url.searchParams), routeLocale(url.pathname))
}
